import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSessionService } from './shared/session/app-session.service';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { IsBusyService } from './shared/services/is-busy.service';
import { ChangePasswordDialogComponent } from "./app/presentation/components/change-password-dialog/change-password-dialog.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, Toast, ConfirmDialog, ChangePasswordDialogComponent],
  template: `
        <p-toast />
        <p-confirmDialog [style]="{ width: '450px' }" [appendTo]="'body'" />
        <app-change-password-dialog  />
        <router-outlet></router-outlet>
    `,
  styles: `
    .fullScreen {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      position: fixed;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 1000;
    }
  `
})
export class AppComponent implements OnInit {
  isBusyService = inject(IsBusyService);
  private appSessionService = inject(AppSessionService);

  ngOnInit(): void {
    this.appSessionService.locaDataFromLocalStorage();
  }
}
